import { JobPhase } from "generated/graphql";

export type PlantRow = {
  key: string;
  plantName: string;
  address: string;
  material: string;
  tons: string;
  truckName: string;
  truckCount: string | number;
};

export function formatHours(seconds?: number | null) {
  if (seconds == null || Number.isNaN(Number(seconds))) return "—";
  return (Number(seconds) / 3600).toFixed(1);
}

export function getCrewHours(jobPhase: JobPhase, crewId?: string | null) {
  const crew = jobPhase?.proposalProduct?.crews?.find(
    (proposalCrew) => `${proposalCrew?.crewId ?? proposalCrew?.id}` === `${crewId}`
  );

  return formatHours(crew?.timeOnjobOverride ?? crew?.timeOnjob);
}

export function getEquipmentRowDetails(jobPhase: JobPhase, equipmentId?: string | null) {
  const equipmentPiece = jobPhase?.proposalProduct?.equipmentPieces?.find(
    (proposalEquipmentPiece) =>
      `${proposalEquipmentPiece?.equipmentPieceId ?? proposalEquipmentPiece?.id}` ===
      `${equipmentId}`
  );

  return {
    quantity: equipmentPiece?.quantityOverride ?? equipmentPiece?.quantity ?? "—",
    hours: formatHours(equipmentPiece?.timeOnjobOverride ?? equipmentPiece?.timeOnjob),
  };
}

export function parsePlantAddress(plantData: any) {
  return [
    plantData?.addressLine1,
    plantData?.addressLine2,
    plantData?.addressCity,
    plantData?.addressState,
    plantData?.addressZip,
  ]
    .filter(Boolean)
    .join(", ");
}

export const denseTableSx = {
  tableLayout: "auto",
  width: "100%",
  "& .MuiTableCell-root": {
    py: 0.9,
    px: 1.25,
    borderColor: "rgba(0, 0, 0, 0.08)",
    verticalAlign: "middle",
  },
  "@media print": {
    tableLayout: "fixed",
    "& .MuiTableCell-root": {
      py: 0.45,
      px: 0.8,
      fontSize: "0.9em",
    },
  },
} as const;

export const headerCellSx = {
  fontWeight: 700,
  backgroundColor: "#f5f5f5",
  color: "#344767",
} as const;
